<template>
  <span class="site-icon" :style="{ fontSize: `${size}px` }">
    <svg :class="`icon-${icon}`" :aria-hidden="true">
      <use :href="symbolId"></use>
    </svg>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

interface IProps {
  prefix?: string;
  icon: string;
  size?: number;
}

const props = withDefaults(defineProps<IProps>(), {
  prefix: 'icon',
  size: 20
});

const symbolId = computed(() => `#${props.prefix}-${props.icon}`);
</script>
